import { cloneDeep } from 'lodash-es'
import React, { memo } from 'react'

import { useTrayCard } from '../../../firebase/hooks/useTray'
import { logMessage } from '../../../Logging/log'

import ActionCard from './Cards/ActionCard/ActionCard'
import BreakerCard from './Cards/BreakerCard'
import ChyronInfoCard from './Cards/ChyronInfoCard'
import { OnCameraCard } from './Cards/ChyronOnCameraCard'
import ChyronSpeakerCard from './Cards/ChyronSpeakerCard'
import { ChyronSpeakersOverviewCard } from './Cards/ChyronSpeakersOverviewCard'
import ComingUpCard from './Cards/ComingUpCard'
import HandoutCard from './Cards/HandoutCard'
import ImageCard from './Cards/ImageCard'
import NoteCard from './Cards/NoteCard'
import VideoCard from './Cards/VideoCard'
import { type PropsWithTrayItemChildren } from './TrayItem'
import { PollCard } from './Cards/PollCard/PollCard'

interface TrayCardIndex {
  id: string
}

const cardsMap = {
  breaker: BreakerCard,
  note: NoteCard,
  video: VideoCard,
  image: ImageCard,
  handout: HandoutCard,
  'chyron-speaker': ChyronSpeakerCard,
  'chyron-speakers-overview': ChyronSpeakersOverviewCard,
  'chyron-info': ChyronInfoCard,
  'chyron-on-camera': OnCameraCard,
  'coming-up': ComingUpCard,
  poll: PollCard,
  action: ActionCard,
}

const NullCard = ({ id }: { id: string }) => {
  const card = useTrayCard(id)

  logMessage('Detected invalid type tray card', {
    level: 'error',
    extra: {
      card: cloneDeep(card),
    },
  })
  return null
}

const TrayCard = ({
  id,
  children,
}: PropsWithTrayItemChildren<TrayCardIndex>) => {
  const card = useTrayCard(id)

  if (!card) return null

  // safeguarding against invalid type tray cards
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const Card = cardsMap[card.type] ?? NullCard

  return <Card id={id}>{children}</Card>
}
const TrayCardMemo = memo(TrayCard)

export { TrayCardMemo as TrayCard }
